// Global addon modal handling
// Works for any `.toggleAddonModal` trigger and matching `.modalAddon` modal

// Toggle modal visibility
function toggleAddonModal(modal) {
  if (!modal) return;

  const isHidden = modal.classList.contains('hidden');
  if (isHidden) {
    modal.classList.remove('hidden');
    modal.classList.add('flex');
  } else {
    modal.classList.add('hidden');
    modal.classList.remove('flex');
  }
}

// Open modal from any trigger with `.toggleAddonModal`
document.addEventListener('click', function (e) {
  const toggleButton = e.target.closest('.toggleAddonModal');
  if (!toggleButton) return;

  e.preventDefault();
  e.stopPropagation();

  const modalId = toggleButton.getAttribute('data-modal-id');
  if (!modalId) return;

  const modal = document.getElementById(modalId);
  toggleAddonModal(modal);
});

// Close modal from close button
document.addEventListener('click', function (e) {
  const closeButton = e.target.closest('.modalAddonClose');
  if (!closeButton) return;

  e.preventDefault();
  e.stopPropagation();

  const modal = closeButton.closest('.modalAddon');
  if (!modal) return;

  modal.classList.add('hidden');
  modal.classList.remove('flex');
});

// Close when clicking on the overlay background
document.addEventListener('click', function (e) {
  if (!e.target.classList.contains('modalAddon')) return;

  e.target.classList.add('hidden');
  e.target.classList.remove('flex');
});

// Close when clicking any button inside the modal (e.g., add-to-cart button)
document.addEventListener('click', function (e) {
  const button = e.target.closest('.modalAddon .button');
  if (!button) return;

  const modal = button.closest('.modalAddon');
  if (!modal) return;

  modal.classList.add('hidden');
  modal.classList.remove('flex');
});


